import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=4f3e80c9&"
import script from "./Message.vue?vue&type=script&lang=ts&"
export * from "./Message.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3794794342/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3e80c9')) {
      api.createRecord('4f3e80c9', component.options)
    } else {
      api.reload('4f3e80c9', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=4f3e80c9&", function () {
      api.rerender('4f3e80c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/components/message/Message.vue"
export default component.exports